import { useParams, useNavigate } from "react-router-dom";
import EventForm from "../../components/forms/EventForm";
import { api } from "../../utils/apiClient";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import ContentLoader from "../../utils/ContentLoader";
import ImageForm from "../../components/forms/ImageForm";


export default function ImageFromPage() {
      const { id } = useParams(); // <-- will be undefined for create
      const navigate = useNavigate();

      const [initialData, setInitialData] = useState({});
      const [fcm, setFcm] = useState("");
      const [eventTitleOptions, setEventTitleOptions] = useState([]);
      const [eventDioceseOptions, setEventDioceseOptions] = useState([]);
      const [eventParisOptions, setEventParisOptions] = useState([]);
      const [loading, setLoading] = useState(false);
      const [showForm, setShowForm] = useState(false);
      const [editData, setEditData] = useState(null);

      useEffect(() => {
            if (id) {
                  fetchImage();
            }
      }, [id]);

      const fetchImage = async () => {
            try {
                  setLoading(true);

                  const res = await api.get(`/images/${id}`);
                  const data = res.data;

                  setInitialData(data);

            } catch (err) {
                  toast.error("Failed to load image data");
            } finally {
                  setLoading(false);
            }
      };

      const handleSubmit = async (formData) => {
            try {
                  setLoading(true);

                  navigate("/image-upload");

            } catch (err) {

                  const errorMessage =
                        Object.values(err?.response?.data?.errors || {})?.[0]?.[0] ||
                        err?.response?.data?.message ||
                        "Something went wrong";

                  toast.error(errorMessage);

            } finally {
                  setLoading(false);
            }
      };

      if (loading) return <ContentLoader />;


      return <ImageForm
            onSubmit={handleSubmit}
            onCancel={() => navigate("/image-upload")}
            initialData={initialData}
      />;
}